import noop from "lodash/noop";

// not used on web, just kept for unified typing across mobile/web
const MaxWaitTimeForAnimationOnRefocusMs = 500;

// on web, native-specific modal handling concerns do not apply
// just kept for unified typing across mobile/web
const useModalCrashAndFreezeSafety = ({
  isVisibilityRequested: isVisible,
  onDismiss: handleDismiss = noop,
}: {
  isVisibilityRequested: boolean;
  onDismiss?: () => void;
}) => ({
  handleDismiss,
  isVisible,
});

export { MaxWaitTimeForAnimationOnRefocusMs };

export default useModalCrashAndFreezeSafety;
